import { createFileRoute } from '@tanstack/react-router'
import { PricingPage } from '../components/pricing-page'
import { staticRouteHead } from '../lib/seo'

export const Route = createFileRoute('/pricing')({
  head: () => staticRouteHead('pricing', 'en'),
  component: PricingPage,
})
